import React, { ReactNode } from "react";
import { style, classes } from "typestyle";

type CenterLayoutProps = {
  direction?: "vertical" | "horizontal";
  className?: string;
  children?: ReactNode;
};
const CenterLayout = ({
  direction,
  children,
  className,
}: CenterLayoutProps): JSX.Element => (
  <div
    className={classes(
      style({
        display: "flex",
        alignItems: "center",
        flexDirection: direction === "vertical" ? "column" : "row",
        justifyContent: "center",
        width: "100%",
        height: "100%",
      }),
      className,
    )}
  >
    {children}
  </div>
);

export default CenterLayout;
